import { Accordion, AccordionSummary, Divider, OutlinedInput, TextField, Button } from '@mui/material'
import { useContext, useState } from 'react'
import { FiltersContainer, Label } from './style/SingleNotificationStyle'
import { UserContext } from '../../context/UserContext'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useTranslation } from 'react-i18next';
import './style.css';
import { useQuery } from '@tanstack/react-query';
import AttToken from '../../helpers/attToken';
import { Autocomplete, Stack } from '@mui/material';
import { IoFilter } from "react-icons/io5";
import { RxReset } from "react-icons/rx";
import { TicketsContext } from '../../context/TickestsContext';
import '@mui/x-date-pickers/themeAugmentation'
import GetFilters from '../../service/GetFilters';
import AutocompleteWithApi from '../Autocomplete/AutocompleteWithApi';
import DatePickerFim from '../DatePicker/DatePickerFim';
import DatePickerInicio from '../DatePicker/DatePickerInicio';
import { trackEventMatomo } from '../../helpers/matomo';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

type props = {
  refetch: Function,
  isFetching: boolean,
  isRefetching: boolean,
  loadingData: boolean
}

const ticketService = new GetFilters();

export default function TicketsFilters({
  refetch,
}: props) {

  const { t } = useTranslation('translation');
  const { userData, hierarchyLabel } = useContext(UserContext)
  const {
    emitidos,
    setEmitidos,
    ordem,
    setOrdem,
    ordenarPor,
    setOrdenarPor,
    userEmissor,
    setUserEmissor,
    modelosNovos,
    setModelosNovos,
    modelos,
    setModelos,
    inicioRangeDe,
    setInicioRangeDe,
    inicioRangeAte,
    setInicioRangeAte,
    previsaoRangeDe,
    setPrevisaoRangeDe,
    previsaoRangeAte,
    setPrevisaoRangeAte,
    clientes,
    setClientes,
    locais,
    setLocais,
    conjuntos,
    setConjuntos,
    unidades,
    setUnidades,
    expirado,
    setExpirado,
    status,
    setStatus,
    setDefaultValues,
    responsavel,
    setResponsavel
  } = useContext(TicketsContext)

  const [openUser, setOpenUser] = useState<boolean>(false)
  const [openCliente, setOpenCliente] = useState<boolean>(false)
  const [openLocal, setOpenLocal] = useState<boolean>(false)
  const [openConjunto, setOpenConjunto] = useState<boolean>(false)
  const [openUnidade, setOpenUnidade] = useState<boolean>(false)
  const [openResponsavel, setOpenResponsavel] = useState<boolean>(false)
  const [openChamadoLegado, setOpenChamadoLegado] = useState<boolean>(false);
  const [openChamado, setOpenChamado] = useState<boolean>(false);

  const orderArray = [
    { inicio: t('notifications.myTickets.dateCreated') },
    { usuarioNome: t('notifications.myTickets.userName') },
    { nome: t('notifications.myTickets.ticketName') },
    { responsavel: t('notifications.myTickets.responsible') },
    { prioridade: t('notifications.myTickets.priority') },
    { novo: t('notifications.myTickets.newModel') },
    { dataPrevisao: t('notifications.myTickets.dueDate') },
    { status: t('notifications.myTickets.status') }
  ]

  const { data: usersResponse, isLoading: isLoadingUsers, refetch: getUsers } = useQuery({
    queryKey: ['GET_USERS'],
    queryFn: async () => {
      const token = await AttToken();
      if (token) {
        const response = await ticketService.getUsuarios(token, true)
        return response.users
      }
    },
    enabled: false,
    keepPreviousData: true,
    refetchOnMount: false,
  })

  const { data: clientesResponse, isLoading: isLoadingClientes, refetch: getClientes } = useQuery({
    queryKey: ['GET_CLIENTES'],
    queryFn: async () => {
      const token = await AttToken();
      if (token) {
        const response = await ticketService.getClientes(token)
        return response.clientes
      }
    },
    enabled: false,
    keepPreviousData: true,
    refetchOnMount: false,
  })

  const { data: locaisResponse, isLoading: isLoadingLocais, refetch: getLocais } = useQuery({
    queryKey: ['GET_LOCAIS'],
    queryFn: async () => {
      const token = await AttToken();
      if (token) {
        const response = await ticketService.getLocais(token)
        return response.locais
      }
    },
    enabled: false,
    keepPreviousData: true,
    refetchOnMount: false,
  })

  const { data: conjuntoResponse, isLoading: isLoadingConjunto, refetch: getConjuntos } = useQuery({
    queryKey: ['GET_CONJUNTO'],
    queryFn: async () => {
      const token = await AttToken();
      if (token) {
        const response = await ticketService.getConjuntos(token)
        return response.conjuntos
      }
    },
    enabled: false,
    keepPreviousData: true,
    refetchOnMount: false,
  })

  const { data: chamadosResponse, isLoading: isLoadingChamados, refetch: getChamados } = useQuery({
    queryKey: ['GET_CHAMADOS'],
    queryFn: async () => {
      const token = await AttToken();
      if (token) {
        const response = await ticketService.getChamados(token, false)
        return response.chamadosNovos
      }
    },
    enabled: false,
    keepPreviousData: true,
    refetchOnMount: false,
  })

  const { data: chamadosLegadoResponse, isLoading: isLoadingChamadosLegado, refetch: getChamadosLegado } = useQuery({
    queryKey: ['GET_CHAMADOSLEGADO'],
    queryFn: async () => {
      const token = await AttToken();
      if (token) {
        const response = await ticketService.getChamados(token, true)
        return response.chamadosLegado
      }
    },
    enabled: false,
    keepPreviousData: true,
    refetchOnMount: false,
  })

  const { data: unidadeResponse, isLoading: isLoadingUnidade, refetch: getUnidades } = useQuery({
    queryKey: ['GET_UNIDADES'],
    queryFn: async () => {
      const token = await AttToken();
      if (token) {
        const response = await ticketService.getUnidades(token)
        return response.unidades
      }
    },
    enabled: false,
    keepPreviousData: true,
    refetchOnMount: false,
  })

  const ordemCheck = (value: string, sortValue: boolean) => {
    switch (value) {
      case 'inicio': case 'dataPrevisao':
        return (sortValue ? t('notifications.myTickets.ascendingDateOrder') : t('notifications.myTickets.descendingDateOrder'))
      case 'usuarioNome': case 'nome': case 'responsavel': case 'prioridade': case 'novo': case 'status':
        return (sortValue ? t('notifications.myTickets.ascendingAlphabeticalOrder') : t('notifications.myTickets.descendingAlphabeticalOrder'))
    }
  }

  return (
    <Accordion className='acordion'>
      <AccordionSummary className='acordionSummary' expandIcon={<ExpandMoreIcon />} >
        <span style={{ width: '100%', textAlign: 'center' }}>{t('table.title')}</span>
      </AccordionSummary>
      <FiltersContainer key={Math.random()}>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="stretch"
          spacing={2}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <span>
              <Label className="checkbox">
                <input
                  onClick={() => trackEventMatomo('filtro chamados', 'click', 'checkbox', 'edita valor')}
                  style={{ marginBottom: '10px' }}
                  checked={emitidos}
                  onChange={(e) => {
                    setEmitidos(e.target.checked)
                  }}
                  type="checkbox"
                />&nbsp;
                {t('notifications.myTickets.showRequestsBy')}&nbsp; <b>{userData.userName}</b>
              </Label>
            </span>
            <Stack direction={window.innerWidth < 600 ? 'column' : 'row'}
              justifyContent="center"
              alignItems="center"
              spacing={1}>
              <Button
                className='button is-danger'
                variant='contained'
                type='submit'
                onClick={() => {
                  trackEventMatomo('filtro chamados', 'click', 'button', 'pesquisar')
                  setEmitidos(false);
                  setDefaultValues()
                  localStorage.removeItem('filtros')
                  refetch()

                }}
                style={{ marginRight: '5px' }}
              >
                {t('notifications.myTickets.cleanFilter')}&nbsp; <RxReset />
              </Button>
              <Button
                className='button is-success'
                variant='contained'
                type='submit'
                onClick={() => {
                  trackEventMatomo('filtro chamados', 'click', 'button', 'limpa filtros')
                  const filter = {
                    emitidos: emitidos,
                    ordenarPor: ordenarPor,
                    ordem: ordem,
                    userEmissor: userEmissor,
                    modelosNovos: modelosNovos,
                    modelos: modelos,
                    inicioRange: {
                      de: new Date(inicioRangeDe).setHours(0, 0, 0, 0),
                      ate: inicioRangeAte
                    },
                    previsaoRange: {
                      de: new Date(previsaoRangeDe).setHours(0, 0, 0, 0),
                      ate: previsaoRangeAte
                    },
                    clientes: clientes,
                    locais: locais,
                    conjuntos: conjuntos,
                    unidades: unidades,
                    expirado: expirado,
                    status: status,
                  };
                  localStorage.setItem('filtros', JSON.stringify(filter))
                }}
              >
                {t('filter')}&nbsp;<IoFilter />
              </Button>
            </Stack>
          </Stack>
          <Label className='filtersTitle'>{t('notifications.myTickets.ordination')}</Label>
          <Divider />
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >

            <Autocomplete
              sx={{ width: '40%' }}
              disableClearable
              defaultValue={ordenarPor || undefined}
              getOptionLabel={option => option.label}
              getOptionKey={option => option.value}
              isOptionEqualToValue={(option, value) => option.value === value.value}
              filterSelectedOptions
              onClick={() => trackEventMatomo('filtro chamados', 'click', 'select', 'seleciona valor')}
              options={orderArray
                ?.map((ele: any) => ({
                  label: String(Object.values(ele)),
                  value: String(Object.keys(ele)),
                }))}
              onChange={(event: any, newValue: { label: string, value: string } | null) => {
                setOrdenarPor(newValue)
              }}
              renderOption={(props, option, { selected }) => (
                <li {...props} key={option.value}>
                  <span>{option.label}</span>
                </li>)}
              renderInput={(params) => <TextField variant='outlined' {...params} label={t('notifications.myTickets.orderBy')} />}
            />
            <Stack
              direction="column"
              justifyContent="center"
              alignItems="flex-start"
              spacing={0.5}
            >
              <Label>{t('notifications.myTickets.orderBy')}</Label>
              <label>
                <input
                  onClick={() => trackEventMatomo('filtro chamados', 'click', 'radio', 'seleciona valor')}
                  onChange={() => setOrdem(true)}
                  defaultChecked={ordem || false}
                  type="radio"
                  name="status" />&nbsp;
                {ordemCheck(ordenarPor?.value as string, true)}
              </label>
              <label>
                <input
                  onClick={() => trackEventMatomo('filtro chamados', 'click', 'radio', 'seleciona valor')}
                  onChange={() => setOrdem(false)}
                  defaultChecked={ordem === false}
                  type="radio"
                  name="status" />&nbsp;
                {ordemCheck(ordenarPor?.value as string, false)}
              </label>
            </Stack>
          </Stack>
          <Label className='filtersTitle'>{t('notifications.myTickets.perDate')}</Label>
          <Divider />
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Stack
              direction="column"
              justifyContent="center"
              alignItems="center"
            >

              <Label>Data de cadastro:</Label>
              <DatePickerInicio maxDate={inicioRangeAte} inicio={inicioRangeDe} setInicio={setInicioRangeDe} />
              <DatePickerFim inicio={inicioRangeDe} fim={inicioRangeAte} setFim={setInicioRangeAte} />
            </Stack>
            <Stack
              direction="column"
              justifyContent="center"
              alignItems="center"
            >
              <Label>Data limite:</Label>
              <DatePickerInicio maxDate={previsaoRangeAte} inicio={previsaoRangeDe} setInicio={setPrevisaoRangeDe} />
              <DatePickerFim inicio={previsaoRangeDe} fim={previsaoRangeAte} setFim={setPrevisaoRangeAte} />
            </Stack>
          </Stack>
          <Label className='filtersTitle'>{t('notifications.myTickets.byUsersResponsibles')}</Label>
          <Divider />
          <AutocompleteWithApi
            open={openUser}
            value={userEmissor}
            setOpen={setOpenUser}
            response={usersResponse}
            loading={isLoadingUsers}
            setValue={setUserEmissor}
            textoVazio={t('notifications.ticketsFilters.noMatchingUsers')}
            callResponse={getUsers}
            textoLoading={t('notifications.ticketsFilters.searchingUsers')}
            textLabel={`${t('Reports.multipleUserSelect')}`}
          />
          <AutocompleteWithApi
            open={openResponsavel}
            value={responsavel}
            setOpen={setOpenResponsavel}
            response={usersResponse}
            loading={isLoadingUsers}
            setValue={setResponsavel}
            textoVazio={t('notifications.ticketsFilters.noMatchingResponsibles')}
            callResponse={getUsers}
            textoLoading={t('notifications.ticketsFilters.searchingResponsibles')}
            textLabel={t('notifications.ticketsFilters.selectOneOrMoreResponsibles')}
          />
          <Label className='filtersTitle'>{t('notifications.ticketsFilters.byTickets')}</Label>
          <Divider />
          {userData.migrado === true &&
            <AutocompleteWithApi
              open={openChamado}
              value={modelosNovos}
              setOpen={setOpenChamado}
              response={chamadosResponse}
              loading={isLoadingChamados}
              setValue={setModelosNovos}
              textoVazio={t('notifications.ticketsFilters.noMatchingTickets')}
              callResponse={getChamados}
              textoLoading={t('notifications.ticketsFilters.searchingTickets')}
              textLabel={t('notifications.ticketsFilters.selectOneOrMoreTicketModels2')}
            />}
          <AutocompleteWithApi
            open={openChamadoLegado}
            value={modelos}
            setOpen={setOpenChamadoLegado}
            response={chamadosLegadoResponse}
            loading={isLoadingChamadosLegado}
            setValue={setModelos}
            textoVazio={t('notifications.ticketsFilters.noMatchingTickets')}
            callResponse={getChamadosLegado}
            textoLoading={t('notifications.ticketsFilters.selectOneOrMoreTicketModels')}
            textLabel={t('notifications.ticketsFilters.selectOneOrMoreTicketModels')}
          />
          <Label className='filtersTitle'>{t('notifications.ticketsFilters.byHierarchy')}</Label>
          <Divider />
          <AutocompleteWithApi
            open={openCliente}
            value={clientes}
            setOpen={setOpenCliente}
            response={clientesResponse}
            loading={isLoadingClientes}
            setValue={setClientes}
            textoVazio={`${t('notifications.ticketsFilters.without')} ${hierarchyLabel.cliente} ${t('notifications.ticketsFilters.corresponding')}`}
            callResponse={getClientes}
            textoLoading={t('notifications.ticketsFilters.searchingClients')}
            textLabel={`${t('notifications.ticketsFilters.selectOne')} ${hierarchyLabel.cliente}`}
          />
          <AutocompleteWithApi
            open={openLocal}
            value={locais}
            setOpen={setOpenLocal}
            response={locaisResponse}
            loading={isLoadingLocais}
            setValue={setLocais}
            textoVazio={`${t('notifications.ticketsFilters.without')} ${hierarchyLabel.local} ${t('notifications.ticketsFilters.corresponding')}`}
            callResponse={getLocais}
            textoLoading={t('notifications.ticketsFilters.searchingLocations')}
            textLabel={`${t('notifications.ticketsFilters.selectOne')} ${hierarchyLabel.local}`}
          />
          <AutocompleteWithApi
            open={openConjunto}
            value={conjuntos}
            setOpen={setOpenConjunto}
            response={conjuntoResponse}
            loading={isLoadingConjunto}
            setValue={setConjuntos}
            textoVazio={`${t('notifications.ticketsFilters.without')} ${hierarchyLabel.conjunto} ${t('notifications.ticketsFilters.corresponding')}`}
            callResponse={getConjuntos}
            textoLoading={t('notifications.ticketsFilters.searchingSets')}
            textLabel={`${t('notifications.ticketsFilters.selectOne')} ${hierarchyLabel.conjunto}`}
          />
          <AutocompleteWithApi
            open={openUnidade}
            value={unidades}
            setOpen={setOpenUnidade}
            response={unidadeResponse}
            loading={isLoadingUnidade}
            setValue={setUnidades}
            textoVazio={`${t('notifications.ticketsFilters.without')} ${hierarchyLabel.unidade} ${t('notifications.ticketsFilters.corresponding')}`}
            callResponse={getUnidades}
            textoLoading={t('notifications.ticketsFilters.searchingSets')}
            textLabel={`${t('notifications.ticketsFilters.selectOne')} ${hierarchyLabel.unidade}`}
          />

          <Label className='filtersTitle'>{t('notifications.ticketsFilters.byStatus')}</Label>
          <Divider />
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={1}
          >
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">{t('notifications.ticketsFilters.expiration')}</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                defaultValue={typeof expirado !== 'boolean' ? 'null' : String(expirado)}
                onClick={() => trackEventMatomo('filtro chamados', 'click', 'select', 'seleciona valor')}
                onChange={(elem) => {
                  console.log(elem.target.value)
                  setExpirado(elem.target.value === 'null' ? null : elem.target.value === 'true' ? true : false)
                }}
                label={t('notifications.ticketsFilters.expiration')}
              >
                <MenuItem value={`${null}`}>{t('notifications.ticketsFilters.showAll')}</MenuItem>
                <MenuItem value={`${true}`}>{t('notifications.ticketsFilters.showOnlyExpiredTickets')}</MenuItem>
                <MenuItem value={`${false}`}>{t('notifications.ticketsFilters.showOnlyTicketsWithinDeadline')}</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Status</InputLabel>
              <Select
                multiple
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={status || []}
                label="Status"
                input={<OutlinedInput label="Select" />}
                onChange={(event) => {
                  console.log(event.target.value, 'event')
                  const value = event.target.value;
                  setStatus(typeof value === 'string' ? value.split(',') : value)
                  if (event.target.value.includes('null')) {
                    setStatus(['null'])
                  } if (event.target.value.length === 5) {
                    setStatus(['null'])
                  }
                }}
              >
                <MenuItem value={'null'}>{t('notifications.ticketsFilters.all')}</MenuItem>
                <MenuItem disabled={status?.includes('null')} value={'concluido'}>{t('notifications.myTickets.completed')}</MenuItem>
                <MenuItem disabled={status?.includes('null')} value={'cancelado'}> {t('notifications.myTickets.canceled')}</MenuItem>
                <MenuItem disabled={status?.includes('null')} value={'emandamento'}> {t('notifications.myTickets.inProgress')}</MenuItem>
                <MenuItem disabled={status?.includes('null')} value={'pendente'}> {t('notifications.myTickets.pending')}</MenuItem>
                <MenuItem disabled={status?.includes('null')} value={'recusado'}> {t('notifications.myTickets.refused')}</MenuItem>
              </Select>
            </FormControl>
          </Stack>
        </Stack>
      </FiltersContainer>
    </Accordion >
  )
}
